import { compact, map, filter, every, isEmpty, some, get, toLower } from 'lodash'

const filteredAssetsData = ({ assets: customers, filters }) => compact(map(customers, (customer) => {
  const assets = filter(customer.assets, asset => {
    const filterResults = {}

    // if (filters.locations != 'All') {
    //   filterResults['locations'] = some(filters.locations, location => location.value === get(asset, 'location'))
    // }
    if (filters.deviceType != 'All') {
      filterResults['deviceType'] = some(filters.deviceType, deviceType => deviceType.value === get(asset, 'device_type'))
    }
    if (filters.dataProtectionStatus != 'All') {
      filterResults['dataProtectionStatus'] = some(filters.dataProtectionStatus, dataProtectionStatus => toLower(dataProtectionStatus.value) === toLower(get(asset, 'data_protection_status')))
    }
    if (filters.dataProtectionCompliance != 'All') {
      filterResults['dataProtectionCompliance'] = some(filters.dataProtectionCompliance, dataProtectionCompliance => toLower(dataProtectionCompliance.value) === toLower(get(asset, 'data_protection_compliance')))
    }
    if (filters.antivirusStatus != 'All') {
      filterResults['antivirusStatus'] = some(filters.antivirusStatus, antivirusStatus => toLower(antivirusStatus.value) === toLower(get(asset, 'antivirus_status')))
    }
    if (filters.antivirusCompliance != 'All') {
      filterResults['antivirusCompliance'] = some(filters.antivirusCompliance, antivirusCompliance => toLower(antivirusCompliance.value) === toLower(get(asset, 'antivirus_compliance')))
    }
    if (filters.patchingStatus != 'All') {
      filterResults['patchingStatus'] = some(filters.patchingStatus, patchingStatus => toLower(patchingStatus.value) === toLower(get(asset, 'patching_status')))
    }
    if (filters.patchingCompliance != 'All') {
      filterResults['patchingCompliance'] = some(filters.patchingCompliance, patchingCompliance => toLower(patchingCompliance.value) === toLower(get(asset, 'patching_compliance')))
    }
    if (filters.monitoringCompliance != 'All') {
      filterResults['monitoringCompliance'] = some(filters.monitoringCompliance, monitoringCompliance => toLower(monitoringCompliance.value) === toLower(get(asset, 'monitoring_compliance')))
    }
    if (filters.customerStatus != 'All') {
      filterResults['customerStatus'] = some(filters.customerStatus, customerStatus => customerStatus.value === get(asset, 'customer_status'))
    }

    if (filters.powerState != 'All') {
      filterResults['powerState'] = some(filters.powerState, powerState => powerState.value === get(asset, 'power_state'))
    }
    if (filters.osSupported != 'All') {
      filterResults['osSupported'] = some(filters.osSupported, osSupported => osSupported.value === get(asset, 'os_supported'))
    }

    if (filters.deviceLastSeen != 'All') {
      filterResults['deviceLastSeen'] = some(filters.deviceLastSeen, lastSeen => (
        get(asset, 'last_seen_in_days') >= lastSeen.value[0] && get(asset, 'last_seen_in_days') <= lastSeen.value[1]
      ))
    }

    return (every(filterResults, (value, key) => value === true) || isEmpty(filterResults))
  })

  if (assets.length == 0) { return null }
  return { ...customer, assets }
}))

export default filteredAssetsData
export { filteredAssetsData }
